export default "__VITE_ASSET__DZxw5cVO__"